module.exports = __webpack_public_path__ + "static/media/lo5d_post_A.80b2b332.svg";